import { useEffect, useRef } from 'react'
import { io } from 'socket.io-client'

/**
 * useKassaSocket — subscribe op real-time bar/kassa events.
 * Server emits `kassa:changed` met `{ scope: 'order'|'account'|'event', ts }`.
 * onChange(payload) wordt aangeroepen bij elk event.
 */
export function useKassaSocket(onChange) {
  const cbRef = useRef(onChange)
  useEffect(() => { cbRef.current = onChange }, [onChange])

  useEffect(() => {
    const token = localStorage.getItem('auth_token')
    if (!token) return
    const s = io({
      auth: { token },
      transports: ['polling', 'websocket'],
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: 10,
    })
    const subscribe = () => s.emit('kassa:subscribe')
    s.on('connect', subscribe)
    s.on('reconnect', subscribe)
    s.on('kassa:changed', (payload) => {
      try { cbRef.current?.(payload) } catch (e) { console.error('kassa:changed handler', e) }
    })
    return () => {
      try { s.emit('kassa:unsubscribe') } catch {}
      s.removeAllListeners()
      s.disconnect()
    }
  }, [])
}
